import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Components from "../../components";
import settings from "./settings";
const AddressUpsert = ({ data, dataSetter }) => {
  const [selectPage, setSelectPage] = useState("address");
  const location = useLocation();
  const navigate = useNavigate();
  const address = location.state;
  const onBackClick = () => {
    console.log(selectPage);
    if (selectPage === "district") {
      setSelectPage("city");
      return;
    }
    if (selectPage === "city") {
      setSelectPage("address");
      return;
    }
    navigate("/account/addresses");
  };
  return (
    <div>
      <Components.PageHeader
        id="page-header"
        label="Page Header"
        title={address?.id ? "Adresi Düzenle" : "Adres Ekle"}
        onBackClick={onBackClick}
        extendedSettings={settings}
        safeArea={data?.system?.safeArea}
        pixelRatio={data?.system?.pixelRatio}
      />
      <Components.AddressUpsert
        id="address-upsert"
        label="Address Upsert"
        extendedSettings={settings}
        selectPage={selectPage}
        setSelectPage={setSelectPage}
        data={data}
        dataSetter={dataSetter}
      />
    </div>
  );
};

export default AddressUpsert;
